import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  FilterAccordionHeader,
  MultiSelection,
} from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import useCubeMetaAPI from '../../../../../hooks/useCubeMetaAPI';
import useFieldLabelsAPI from '../../../../../hooks/useFieldLabelsAPI';
import { required } from '../../../../../helpers/Validations';

function TablesField({ selectedTables, setSelectedTables }) {
  const cubeMetaData = useCubeMetaAPI();
  const { getLabel } = useFieldLabelsAPI({ fieldType: 'table' });
  const [filterToggle, setFilterToggle] = useState(true);
  const intl = useIntl();

  return (
    <Accordion
      id="query-builder-form-tables-accordion"
      label={
        <FormattedMessage
          id="ui-reports.queryBuilder.tablesField.Accordion.header"
          defaultMessage="Tables Options"
        />
      }
      onToggle={() => setFilterToggle(!filterToggle)}
      open={filterToggle}
      separator
      header={FilterAccordionHeader}
    >
      <MultiSelection
        id="query-builder-form-table-multiselect"
        label={
          <FormattedMessage
            id="ui-reports.queryBuilder.tablesField.label"
            defaultMessage="Tables"
          />
        }
        placeholder={intl.formatMessage({
          id: 'ui-reports.queryBuilder.tableField.placeholder',
          defaultMessage: 'Choose table',
        })}
        dataOptions={cubeMetaData?.response?.cubes?.map((option) => ({
          label: getLabel(`view.${option.name}`) || option.title || option.name,
          value: option.name,
        }))}
        required
        validate={required}
        value={selectedTables}
        onChange={setSelectedTables}
      />
    </Accordion>
  );
}

TablesField.propTypes = {
  selectedTables: PropTypes.arrayOf(PropTypes.string),
  setSelectedTables: PropTypes.func.isRequired,
};

export default TablesField;
